<template>
    <svg :class="['svg-icon',{isImg:isImg}]" aria-hidden="true" v-on="$listeners">
        <use :xlink:href="iconName" />
    </svg>
</template>

<script>
// 图标别名
const iconNameAlias = {
    PPTX: 'PPT',
    PPTS: 'PPT',
    XLS: 'EXCEL',
    XLSX: 'EXCEL',
    DOC: 'WORD',
    DOCX: 'WORD',
    PNG: 'PIC',
    JPG: 'PIC',
    JPEG: 'PIC',
    GIF: 'PIC',
    RAR: 'ZIP',
    ZIP: 'ZIP',
    '7Z': 'ZIP',
    YASUO: 'ZIP',
    GONGWEN: 'SYSTEM',
    PRP: 'DGN1',
    PRW: 'DGN1',
    SQL: 'ODBC',
};
export default {
    name: 'SvgIcon',
    props: {
        icon: { // 图标名称
            name: String,
            required: true,
        },

    },
    computed: {
        iconName() {
            return `#icon-${this.getIconName(this.icon)}`;
        },
        isImg(){
            return this.getIconName(this.icon) == 'PIC'
        }
    },
    methods: {
        // 获取对应的图标名称
        getIconName(name) {
            name = name.toUpperCase();
            let iconName = this.$svgIconList.includes(name) ? name : '';
            let alias = iconNameAlias[name];
            if (!iconName && alias && this.$svgIconList.includes(alias)) {
                iconName = alias;
            }
            !iconName && (iconName = 'OTHER');
            return iconName;
        },
    },
};
</script>

<style lang="scss" scoped>
.svg-icon {
    fill: currentColor;
    overflow: hidden;
    &.isImg{

        width:30px;
    }
}
</style>
